<template>
  <tr class="invoice-product--item-row" v-if="product">
    <td>
      <p>
        <span v-if="productData">{{ productData.name }}</span>
      </p>
      <p>{{ rangeDate }}</p>
    </td>
    <td>
      <p>
        <span v-if="termData">
          {{ termData.name }}
        </span>
        <span v-else>None</span>
      </p>
    </td>
    <td>
      <p>
        <span>
          {{ product.quantity }}
        </span>
      </p>
    </td>
    <td>
      <p>
        <span class="d-flex justify-content-end">
          {{ convertToMoney(price) }}
        </span>
      </p>
    </td>
  </tr>
</template>

<script>
import axios from "@/helpers/axios";
import moment from "@/helpers/moment";
import _ from "lodash";

export default {
  props: {
    product: {
      type: [Object],
      default: null
    },
    index: {
      type: [Number],
      default: null
    }
  },
  data() {
    return {
      productData: null,
      termData: null
    };
  },
  created() {
    this.getProductData();
    this.getTermData();
  },
  computed: {
    rangeDate() {
      const {
        product: { startAt, endAt }
      } = this;
      var start = moment(startAt);
      var end = moment(endAt);
      if (start.format("MMM DD") === end.format("MMM DD")) {
        return start.format("LLL") + " - " + end.format("LT");
      } else {
        return (
          start.format("MMM DD, YYYY h:mm A") +
          " to " +
          end.format("MMM DD, YYYY h:mm A")
        );
      }
    },
    duration() {
      const {
        product: { startAt, endAt }
      } = this;
      var start = moment(startAt);
      var end = moment(endAt);
      if (start.format("MMM DD") === end.format("MMM DD")) {
        return (
          end
            .diff(start, "hours", true)
            .toLocaleString("en-US", { maximumFractionDigits: 2 }) + " hours"
        );
      } else if (start.format("MMM") === end.format("MMM")) {
        return (
          end
            .diff(start, "days", true)
            .toLocaleString("en-US", { maximumFractionDigits: 2 }) + " days"
        );
      } else {
        return (
          end
            .diff(start, "months", true)
            .toLocaleString("en-US", { maximumFractionDigits: 2 }) + " months"
        );
      }
    },
    price() {
      if (this.termData && this.productData) {
        const term = _.find(this.productData.Terms, { id: this.termData.id });
        const { hasStartDate, calculatedValue, calculatedBy, Package } = term;
        const {
          product: { startAt, endAt, amount }
        } = this;
        var start = moment(startAt);
        var end = moment(endAt);
        const price = amount > 0 ? amount : Package.price;
        var total;
        if (hasStartDate && amount == 0) {
          total =
            end && start
              ? (end.diff(start, calculatedBy, true) / calculatedValue) * price
              : null;
        } else {
          total = price;
        }
        return total;
      } else {
        return 0;
      }
    }
  },
  methods: {
    convertToMoney(amount) {
      return (
        "Php " + amount.toLocaleString("en-US", { minimumFractionDigits: 2 })
      );
    },
    getProductData() {
      const { product } = this;
      axios.get("/products/" + product.Package.productId).then(response => {
        this.productData = response.data.data;
      });
    },
    getTermData() {
      const { product } = this;
      axios.get("/terms/" + product.Package.termId).then(response => {
        this.termData = response.data.data;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.invoice-product {
  &--item-row {
    border-bottom: 1px solid #cccccc;
    td {
      vertical-align: top;
      font-family: "Arial";
      font-size: 16px;
      padding: 20px 0;
    }
    p {
      margin: 0;
    }
    span {
      font-family: "Arial";
    }
  }
}
</style>
